import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 9.00001V16H6V9.00001H8Z" fill={ fill || 'currentColor' } />
        <path d="M13 9.00001V16H11V9.00001H13Z" fill={ fill || 'currentColor' } />
        <path d="M18 9.00001V16H16V9.00001H18Z" fill={ fill || 'currentColor' } />
        <path d="M2 8.91001L12 4.11001L22 8.91001V6.69001L12 1.89001L2 6.69001V8.91001Z" fill={ fill || 'currentColor' } />
        <path d="M22 20V22H2V20H22Z" fill={ fill || 'currentColor' } />
        <path d="M20 17V19H4V17H20Z" fill={ fill || 'currentColor' } />
    </svg>

);
